module.exports = __webpack_public_path__ + "static/img/qrcode.b4f9b69b.jpg";